// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Vo-z","breadcrumbForward":"Wo-z","breadcrumbBack":"Xo-z","selected":"Yo-z"};